import { render, staticRenderFns } from "./backoffice-orcamento.vue?vue&type=template&id=ca0eeb38&scoped=true"
import script from "./backoffice-orcamento.vue?vue&type=script&lang=ts"
export * from "./backoffice-orcamento.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-orcamento.vue?vue&type=style&index=0&id=ca0eeb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0eeb38",
  null
  
)

export default component.exports